export default __webpack_public_path__ + "static/media/sandy_lowpoly_uv2.2926c4fd.FBX";